import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface BusinessTypeColumnProps {
  businessTypeId?: string;
}

export const BusinessTypeColumn = ({ businessTypeId }: BusinessTypeColumnProps) => {
  const { data: businessTypes } = useQuery({
    queryKey: ['businessTypes'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('business_types')
        .select('*');
      
      if (error) throw error;
      return data;
    }
  });

  const getBusinessTypeName = (business_type_id: string) => {
    const businessType = businessTypes?.find(bt => bt.id === business_type_id);
    return businessType?.name || 'N/A';
  };

  return <span>{businessTypeId ? getBusinessTypeName(businessTypeId) : 'N/A'}</span>;
};